import HomeContent from "$lib/data/generated/content/home/data.json";

import { uploads as HomeUploads } from "$lib/data/generated/uploads/home/uploads";

const content = {
	["home"]: HomeContent
};
const uploads = {
	...HomeUploads
};


export const prerender = 'auto';
export const entries = () => {
	if (false) return [];
	return ['/admin'];
};

export const load = async ({ parent }) => {
	const data = await parent();

	data.content = { ...data.content, ...content };
	data.uploads = { ...data.uploads, ...uploads };

	return data;
};
